import React, { Component } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

export default class Notification extends Component {
    static displayName = Notification.name;

    render() {
        return (
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={this.props.open}
                onClose={this.props.onClose}
                autoHideDuration={10000}
            >
                <Alert
                    onClose={this.props.onClose}
                    severity={this.props.severity}
                    elevation={6}
                    variant="filled"
                >
                    {this.props.message}
                </Alert>
            </Snackbar>
        );
    }
}
